import {
    InsuranceCoverageToAcceptSerializer,
    SmartInsuranceVerificationDetailSerializer,
    UserSimpleSerializer,
} from '../../../@core/api.service';
import {SMART_INSURANCE_VERIFICATION_STATUS_CHOICES} from '../../../@core/smart_insurance_verification_status_choices';
import {InsuranceEligibility} from '../../../models/insurance-eligibility';

export class SmartInsuranceVerification implements Omit<SmartInsuranceVerificationDetailSerializer, 'eligibility_requests'> {
    id?: number;
    user?: UserSimpleSerializer;
    eligibility_requests: InsuranceEligibility[];
    coverages_to_accept?: Array<InsuranceCoverageToAcceptSerializer>;
    status?: keyof typeof SMART_INSURANCE_VERIFICATION_STATUS_CHOICES;
    error_message?: string;
    timestamp?: Date | string;
    update_insurance_settings?: boolean;
    accepted_date?: Date | string;
    patient?: number;

    constructor(data: SmartInsuranceVerificationDetailSerializer) {
        if (!data) return;
        Object.assign(this, data);
        this.eligibility_requests = (data.eligibility_requests ?? []).map(
            er => new InsuranceEligibility(er)
        );
    }
}
